import { createTheme } from '@material-ui/core/styles';

export const eAbwasserTheme = createTheme({
    typography: {
        fontSize: 11.2,
        fontFamily: "Verdana, Arial, Helvetica, sans-serif",
    },
    palette: {
        primary: {
            main: "#8DB2E3",
            light: "#CBDDF8",
            dark: "#254780",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "#8DB2E3",
            light: "#CBDDF8",
            dark: "#254780",
            contrastText: "#ffffff",
        },
        text: {
            primary: "#000000",
            disabled: "#4d4d4d",
            secondary: "#000000",
            hint: "#000000",
        },
    },

    overrides: {
        MuiTab: {
            root: {
                minWidth: "140px !important",
            },
        },
        MuiFormLabel: {
            root: {
                color: "#797979",
            },
        },
        MuiDialogTitle: {
            root: {
                padding: "10px 10px 0px 10px",
            },
        },
        MuiTreeItem: {
            root: {
                // "&:hover > $content": {
                //     backgroundColor: "#eee",
                // },
                "&:focus > $content $label": {
                    backgroundColor: "transparent",
                },
                "&$selected > $content": {
                    backgroundColor: "#CBDDF8",
                    color: "#000000",
                },
                "&:focus > $content $label, &:hover > $content $label, &$selected > $content $label": {
                    backgroundColor: "transparent",
                },
            },
            label: {
                wordBreak: "normal",
                overflowWrap: "anywhere",
            },
        },
        MuiAutocomplete: {
            inputRoot: {
                '&[class*="MuiOutlinedInput-root"]': {
                    "$hasPopupIcon$hasClearIcon &": {
                        paddingRight: 50,
                    },
                },
            },
        },
    },
});
